import React, {Component, Fragment} from 'react';
import {Row, Card, CardTitle, Button} from 'reactstrap';
import {NavLink} from 'react-router-dom';
import {Colxx} from '../components/common/CustomBootstrap';
import {withTranslation} from 'react-i18next';

class Error extends Component {
  componentDidMount() {
    document.body.classList.add('background');
  }

  componentWillUnmount() {
    document.body.classList.remove('background');
  }

  render() {
    const {t} = this.props;
    return (
      <Fragment>
        <div className="fixed-background"/>
        <main>
          <div className="container">
            <Row className="h-100">
              <Colxx xxs="12" md="10" className="mx-auto my-auto">
                <Card className="auth-card">
                  <div className="position-relative image-side ">
                    {/*<p className="text-white h2">MAGIC IS IN THE DETAILS</p>*/}
                    {/*<p className="white mb-0">Yes, it is indeed!</p>*/}
                  </div>
                  <div className="form-side">
                    <NavLink to={'/'} className="white">
                      {/*<span className="logo-single"/>*/}
                    </NavLink>
                    <CardTitle className="mb-4">
                      {t('Ooops... looks like an error occurred!')}
                    </CardTitle>
                    <p className="mb-0 text-muted text-small mb-0">
                      {t('Error code')}
                    </p>
                    <p className="display-1 font-weight-bold mb-5">404</p>
                    <Button
                      href="/dashboard"
                      color="primary"
                      className="btn-shadow"
                      size="lg"
                    >
                      {t('GO BACK HOME')}
                    </Button>
                  </div>
                </Card>
              </Colxx>
            </Row>
          </div>
        </main>
      </Fragment>
    );
  }
}

export default withTranslation()(Error);
